var map = {
	"./an_giang.png": "06fd",
	"./bac_lieu.png": "0f76",
	"./ben_tre.png": "51f6",
	"./binh_dinh.png": "42ac",
	"./binh_duong.png": "c787",
	"./binh_phuoc.png": "d815",
	"./binh_thuan.png": "fc04",
	"./ca_mau.png": "1104",
	"./can_tho.png": "f766",
	"./da_nang.png": "d346",
	"./dak_lak.png": "ac2d",
	"./dak_nong.png": "42a3",
	"./dong_nai.png": "0756",
	"./dong_thap.png": "3ae1",
	"./gia_lai.png": "f269",
	"./hau_giang.png": "38ea",
	"./ho_chi_minh.png": "9ee5",
	"./khanh_hoa.png": "58cb",
	"./kien_giang.png": "0b1a",
	"./kon_tum.png": "149d",
	"./lam_dong.png": "929b",
	"./long_an.png": "3961",
	"./mien_bac.png": "f752",
	"./ninh_thuan.png": "e793",
	"./phu_yen.png": "d51c",
	"./quang_binh.png": "b984",
	"./quang_nam.png": "06ad",
	"./quang_ngai.png": "b05a",
	"./quang_tri.png": "84cb",
	"./soc_trang.png": "772b",
	"./tay_ninh.png": "2185",
	"./thua_thien_hue.png": "47f1",
	"./tien_giang.png": "a858",
	"./tra_vinh.png": "7d62",
	"./vinh_long.png": "0cfe",
	"./vung_tau.png": "1510"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce98";